import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const css = `
.topbar { display:flex; align-items:center; justify-content:space-between; padding:11px 24px;
  background:rgba(10,15,26,0.97); border-bottom:1px solid rgba(109,190,69,0.2);
  position:sticky; top:0; z-index:100; backdrop-filter:blur(12px); }
.logo-wrap { display:flex; align-items:center; gap:10px; text-decoration:none; flex-shrink:0; }
.logo-img { width:64px; height:64px; object-fit:contain; }
.logo-text { font-family:'Barlow Condensed',sans-serif; font-size:26px; font-weight:800;
  color:#F0F6FF; letter-spacing:1px; line-height:1; }
.logo-text span { color:#6DBE45; }
.logo-sub { font-size:9px; letter-spacing:2px; text-transform:uppercase; color:#556677;
  font-family:'DM Sans',sans-serif; font-weight:600; margin-top:4px; }
.topbar-nav { display:flex; gap:8px; align-items:center; }
.nav-link { padding:7px 14px; border-radius:6px; font-size:13px; font-weight:500;
  color:#8899AA; background:transparent; border:none; cursor:pointer;
  text-decoration:none; transition:all 0.2s; display:inline-block; }
.nav-link:hover { color:#F0F6FF; background:rgba(255,255,255,0.06); text-decoration:none; }
.nav-link.active { color:#1E7FD4; background:rgba(30,127,212,0.1); }
.nav-chip { padding:7px 16px; border-radius:6px; font-size:13px; font-weight:600;
  border:none; cursor:pointer; transition:all 0.2s; text-decoration:none; display:inline-block; }
.nav-chip.blue { background:#1E7FD4; color:#fff; }
.nav-chip.blue:hover { background:#2E8FE4; text-decoration:none; }
.nav-chip.green { background:#6DBE45; color:#0A0F1A; }
.nav-chip.green:hover { background:#7DCE55; text-decoration:none; }
.nav-chip.ghost { background:rgba(255,255,255,0.06); color:#AAB8C8; border:1px solid rgba(255,255,255,0.1); }
.nav-chip.ghost:hover { background:rgba(255,255,255,0.1); text-decoration:none; }

/* Mobile: hide secondary nav items, keep it clean */
@media(max-width:640px){
  .topbar { padding:10px 16px; }
  .logo-img { width:48px; height:48px; }
  .logo-text { font-size:22px; }
  .logo-sub { display:none; }
  .hide-mobile { display:none !important; }
  .nav-chip.green { padding:6px 12px; font-size:12px; }
  .nav-chip.blue { padding:6px 12px; font-size:12px; }
}
`;

export default function Topbar() {
  const { user, role, logout } = useAuth();
  const nav = useNavigate();
  const handleLogout = () => { logout(); nav('/'); };
  const dashLink = role === 'provider' ? '/provider/dashboard' : role === 'admin' ? '/admin' : '/dashboard';

  return (
    <>
      <style>{css}</style>
      <nav className="topbar">
        <Link to="/" className="logo-wrap">
          <img src="/logo.png" alt="iTekPros" className="logo-img" />
          <div>
            <div className="logo-text">iTek<span>Pros</span></div>
            <div className="logo-sub">Verified DC Professionals</div>
          </div>
        </Link>
        <div className="topbar-nav">
          <Link to="/browse" className="nav-link hide-mobile">Browse Pros</Link>
          {!user ? (
            <>
              <Link to="/login" className="nav-link hide-mobile">Sign In</Link>
              <Link to="/join" className="nav-chip green">Join as Pro</Link>
              <Link to="/register" className="nav-chip blue hide-mobile">Hire a Pro</Link>
            </>
          ) : (
            <>
              <Link to={dashLink} className="nav-link active hide-mobile">
                {role === 'admin' ? '⚙ Admin' : role === 'provider' ? 'My Dashboard' : 'My Jobs'}
              </Link>
              <button onClick={handleLogout} className="nav-chip ghost">Sign Out</button>
            </>
          )}
        </div>
      </nav>
    </>
  );
}
